import I18n from 'I18n';
import { getDealAmountPreference } from 'products-ui-components/utils/dealAmount';
import { DEAL_AMOUNT_FIELD_NAME, DEAL_CURRENCY_FIELD_NAME, MAP_DEAL_REFERENCE_TYPE_TO_TRANSACTION } from '../../constants/associations';
export const SET_CURRENCY = 'SET_CURRENCY';
export const SET_FORM_FIELDS = 'SET_FORM_FIELDS';
export const SET_FIELD = 'SET_FIELD';
export const SET_CRM_OBJECT_ASSOCIATIONS = 'SET_CRM_OBJECT_ASSOCIATIONS';
export const SAVE_PRODUCTS = 'SAVE_PRODUCTS';
export const CALCULATE_PROPERTIES = 'CALCULATE_PROPERTIES';
export const SAVE_NEW_LINE_ITEMS = 'SAVE_NEW_LINE_ITEMS';
export const SAVE_CURRENCIES_INFO = 'SAVE_CURRENCIES_INFO';
export const RESET_NEW_LINE_ITEMS = 'RESET_NEW_LINE_ITEMS';
export const SET_DEAL_AMOUNT_CALCULATION_PROPERTY = 'SET_DEAL_AMOUNT_CALCULATION_PROPERTY';
export const SET_DEAL_TOTAL_AMOUNT = 'SET_DEAL_TOTAL_AMOUNT';
export const GET_PROPERTIES = 'GET_PROPERTIES';
export const SET_PROPERTIES = 'SET_PROPERTIES';
export const CREATE_CRM_OBJECT = 'CREATE_CRM_OBJECT';
export const CREATE_CRM_OBJECT_PENDING = 'CREATE_CRM_OBJECT_PENDING';
export const CREATE_CRM_OBJECT_FULFILLED = 'CREATE_CRM_OBJECT_FULFILLED';
export const CREATE_CRM_OBJECT_REJECTED = 'CREATE_CRM_OBJECT_REJECTED';
export const SET_ASSOCIATION_PROPERTIES = 'SET_ASSOCIATION_PROPERTIES';
export const RESET_SEARCH_PROPERTIES = 'RESET_SEARCH_PROPERTIES';
export const SET_LEGACY_DEAL_AMOUNT_CALCULATION = 'SET_LEGACY_DEAL_AMOUNT_CALCULATION';
export const GET_CURRENCIES = 'GET_CURRENCIES';
export const GET_DEAL_AMOUNT_SETTINGS = 'GET_DEAL_AMOUNT_SETTINGS';
export const RESET_CRM_OBJECT_ASSOCIATIONS = 'RESET_CRM_OBJECT_ASSOCIATIONS';
export const RESET_FORM_ERROR = 'RESET_FORM_ERROR';
export const initialState = {
  currency: '',
  formFields: [],
  crmObjectAssociations: {},
  productEntities: {},
  newLineItems: [],
  hasMulticurrencyActive: false,
  currencyExchangeRates: [],
  homeCurrency: '',
  dealAmountPreference: '',
  hasLegacyDealAmountCalculation: false,
  dealTotalAmount: null,
  crmObjectSearchProperties: [],
  crmObjectCreationFormErrorMessage: '',
  associationProperties: []
};
export const reducer = (state, action) => {
  switch (action.type) {
    case SET_CURRENCY:
      return Object.assign({}, state, {
        currency: action.payload
      });
    case SET_FORM_FIELDS:
      return Object.assign({}, state, {
        formFields: action.payload
      });
    case SET_FIELD:
      {
        const {
          key,
          value
        } = action.payload;
        const fieldToUpdateIndex = state.formFields.findIndex(el => el.name === key);
        const updatedField = Object.assign({}, state.formFields[fieldToUpdateIndex], {
          value,
          valid: true
        });
        state.formFields.splice(fieldToUpdateIndex, 1, updatedField);
        return Object.assign({}, state, {
          formFields: state.formFields.slice(),
          currency: key === DEAL_CURRENCY_FIELD_NAME ? value : state.currency
        });
      }
    case SET_CRM_OBJECT_ASSOCIATIONS:
      {
        const {
          associationTypeId,
          associationsIds
        } = action.payload;
        return Object.assign({}, state, {
          crmObjectAssociations: Object.assign({}, state.crmObjectAssociations, {
            [associationTypeId]: associationsIds
          })
        });
      }
    case RESET_CRM_OBJECT_ASSOCIATIONS:
      return Object.assign({}, state, {
        crmObjectAssociations: {}
      });
    case SAVE_PRODUCTS:
      {
        const stateEntitites = state.productEntities;
        action.payload.forEach(product => {
          stateEntitites[product.id] = product;
        });
        return Object.assign({}, state, {
          productEntities: Object.assign({}, stateEntitites)
        });
      }
    case SAVE_NEW_LINE_ITEMS:
      return Object.assign({}, state, {
        newLineItems: action.payload
      });
    case SAVE_CURRENCIES_INFO:
      {
        const newState = Object.assign({}, state, {
          homeCurrency: action.payload.homeCurrency.currencyCode,
          hasMulticurrencyActive: action.payload.hasMulticurrencyActive,
          currencyExchangeRates: action.payload.currencyExchangeRates
        });

        // set home currency if we don`t have other curremcies
        if (!action.payload.hasMulticurrencyActive) {
          newState.currency = action.payload.homeCurrency.currencyCode;
        }
        return newState;
      }
    case RESET_NEW_LINE_ITEMS:
      {
        const dealAmountFormFieldIndex = state.formFields.findIndex(field => field.name === DEAL_AMOUNT_FIELD_NAME);
        if (dealAmountFormFieldIndex !== -1) {
          const dealAmountFormField = state.formFields[dealAmountFormFieldIndex];
          dealAmountFormField.disabled = false;
          dealAmountFormField.value = '';
          dealAmountFormField.tooltip = '';
          state.formFields.splice(dealAmountFormFieldIndex, 1, dealAmountFormField);
        }
        return Object.assign({}, state, {
          newLineItems: [],
          dealTotalAmount: null,
          formFields: state.formFields.slice()
        });
      }
    case SET_DEAL_AMOUNT_CALCULATION_PROPERTY:
      return Object.assign({}, state, {
        dealAmountPreference: getDealAmountPreference(action.payload, state.hasLegacyDealAmountCalculation)
      });
    case SET_DEAL_TOTAL_AMOUNT:
      {
        const dealAmountFormFieldIndex = state.formFields.findIndex(field => field.name === DEAL_AMOUNT_FIELD_NAME);
        if (dealAmountFormFieldIndex !== -1) {
          const dealAmountFormField = state.formFields[dealAmountFormFieldIndex];
          dealAmountFormField.disabled = true;
          dealAmountFormField.tooltip = I18n.text('associationsPanel.tabs.create.dealAmountTooltip', {
            dealAmountPreference: I18n.text(`associationsPanel.tabs.create.${MAP_DEAL_REFERENCE_TYPE_TO_TRANSACTION[state.dealAmountPreference]}`)
          });
          if (action.payload) {
            dealAmountFormField.value = action.payload.toFixed(2);
          } else {
            dealAmountFormField.value = '0.00';
          }
          state.formFields.splice(dealAmountFormFieldIndex, 1, dealAmountFormField);
        }
        return Object.assign({}, state, {
          dealTotalAmount: action.payload,
          formFields: state.formFields.slice()
        });
      }
    case SET_PROPERTIES:
      return Object.assign({}, state, {
        crmObjectSearchProperties: action.payload
      });
    case CREATE_CRM_OBJECT_FULFILLED:
    case CREATE_CRM_OBJECT_PENDING:
    case RESET_FORM_ERROR:
      return Object.assign({}, state, {
        crmObjectCreationFormErrorMessage: ''
      });
    case CREATE_CRM_OBJECT_REJECTED:
      return Object.assign({}, state, {
        crmObjectCreationFormErrorMessage: action.payload
      });
    case SET_ASSOCIATION_PROPERTIES:
      return Object.assign({}, state, {
        associationProperties: action.payload
      });
    case RESET_SEARCH_PROPERTIES:
      return Object.assign({}, state, {
        associationProperties: [],
        crmObjectSearchProperties: []
      });
    case SET_LEGACY_DEAL_AMOUNT_CALCULATION:
      return Object.assign({}, state, {
        hasLegacyDealAmountCalculation: action.payload
      });
    default:
      return state;
  }
};